export default __webpack_public_path__ + "static/media/ValueLabs.448b8991.webp";